import INF_Table from "./table";

export default INF_Table;
